export const RedeemStatusCssClasses = ["info", "success", "danger", "warning"];
export const RedeemStatusTitles = ["Pending", "Sent", "Rejected", "On Hold"];
export const RedeemTypeCssClasses = ["success", "primary", ""];
export const RedeemTypeTitles = ["Business", "Individual", ""];
export const defaultSorted = [{ dataField: "redeemDate", order: "desc" }];
export const sizePerPageList = [
  { text: "3", value: 3 },
  { text: "5", value: 5 },
  { text: "10", value: 10 }
];
export const initialFilter = {
  filter: {
    username: "",
  },
  sortOrder: "desc", // asc||desc
  sortField: "redeemDate",
  pageNumber: 1,
  pageSize: 10
};
